(function () {
  var data = window.__defaultVariantData;
  if (!data || !data.variants || !data.preferredValue) return;

  var params = new URLSearchParams(window.location.search);
  if (params.has('variant')) return; // el cliente ya trae una talla elegida (ej. desde un enlace directo)

  var preferred = data.variants.find(function (v) {
    return v.available && [v.option1, v.option2, v.option3].indexOf(data.preferredValue) !== -1;
  });

  if (preferred) {
    params.set('variant', preferred.id);
    window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
  }
})();